
export const DISPLAY_OPTIONS = {
  HIDE_ALL: 'hideAll',
  SHOW_ALL_AWARDS: 'showAllAwards',
  SHOW_ALL_KEYWORDS: 'showAllKeywords',
  SHOW_ALL: 'showAll',
};
